import React from "react";
import ModalBox from "../ModalBox/ModalBox";
import PasswordInput from "../PasswordInput/PasswordInput";
import PrimaryButton from "../PrimaryButton/PrimaryButton";
import Loader from "../Loader/Loader";
import SuccessModal from "./Success/Success";
import FailedModal from "./Fail/Fail";
import InputErrorMessage from "../InputErrorMessage/InputErrorMessage";
import call from "../../API/API";
import { psw_regex } from "../../regex/regex";
import "./ChangePasswordModal.css";

class ChangePasswordModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      oldPassword: "",
      newPassword: "",
      status: 0,
      error: "",
      oldPswErrValidation: "",
      newPswErrValidation: "",
    };
    //status:
    //1 => communicating with backend/Loading
    //2 => success
    //3 => fail
    //else => pending

    this.handleOldPasswordOnChange = this.handleOldPasswordOnChange.bind(this);
    this.handleNewPasswordOnChange = this.handleNewPasswordOnChange.bind(this);
    this.handlePasswordOnChange = this.handlePasswordOnChange.bind(this);
    this.validateOldPassword = this.validateOldPassword.bind(this);
    this.validateNewPassword = this.validateNewPassword.bind(this);
  }

  validateOldPassword() {
    const result = this.state.oldPassword.match(psw_regex);
    if (result) {
      this.setState({
        newPswErrValidation: "",
        oldPswErrValidation: "",
      });
      return true;
    } else {
      this.setState({
        oldPswErrValidation: "Password needs to be 8 characters or more",
        newPswErrValidation: "",
      });
      return false;
    }
  }

  validateNewPassword() {
    const result = this.state.newPassword.match(psw_regex);
    if (result) {
      this.setState({
        newPswErrValidation: "",
        oldPswErrValidation: "",
      });
      return true;
    } else {
      this.setState({
        newPswErrValidation: "Password needs to be 8 characters or more",
        oldPswErrValidation: "",
      });
      return false;
    }
  }

  handleOldPasswordOnChange(e) {
    this.setState({
      oldPassword: e.target.value,
    });
  }

  handleNewPasswordOnChange(e) {
    this.setState({
      newPassword: e.target.value,
    });
  }

  handlePasswordOnChange() {
    const oldPswValidation = this.validateOldPassword();
    console.log(oldPswValidation);
    if (oldPswValidation) {
      const newPswErrValidation = this.validateNewPassword();
      console.log(newPswErrValidation);
      if (newPswErrValidation) {
        this.setState(
          {
            status: 1,
          },
          () => {
            call.users_API
              .changePassword(this.state.oldPassword, this.state.newPassword)
              .then((response) => {
                console.log(response);
                if (response.success) {
                  this.setState({
                    status: 2,
                  });
                } else {
                  if (response.results === "Old password doesn't match!") {
                    this.setState({
                      newPswErrValidation: "",
                      oldPswErrValidation: "Old password doesn't match!",
                      error: "",
                      status: 0,
                    });
                  } else if (
                    response.results === "Cannot put the same password!"
                  ) {
                    this.setState({
                      newPswErrValidation:
                        "New password cannot be the same as old password!",
                      oldPswErrValidation: "",
                      error: "",
                      status: 0,
                    });
                  } else {
                    this.setState({
                      newPswErrValidation: response.results,
                      oldPswErrValidation: "",
                      error: "",
                      status: 0,
                    });
                  }
                }
              })
              .catch((err) => {
                this.setState({
                  error: err.message,
                  status: 3,
                });
              });
          }
        );
      }
    }
  }

  render() {
    return (
      <ModalBox
        handleModalOnClose={this.props.handleModalOnClose}
        modalClassName="change-password-modal"
      >
        {this.state.status === 1 ? (
          <Loader />
        ) : this.state.status === 2 ? (
          <SuccessModal />
        ) : this.state.status === 3 ? (
          <FailedModal />
        ) : (
          <>
            <h2 className="headline-4">Change password</h2>
            <form className="modal-form" onSubmit={(e) => e.preventDefault()}>
              <div className="modal-form-old-psw">
                <PasswordInput
                  label="Old password"
                  placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;"
                  id="old-password"
                  value={this.state.oldPassword}
                  handleTextInputOnChange={this.handleOldPasswordOnChange}
                />
                {this.state.oldPswErrValidation ? (
                  <InputErrorMessage
                    errorText={this.state.oldPswErrValidation}
                  />
                ) : null}
              </div>
              <div className="modal-form-new-psw">
                <PasswordInput
                  label="New password"
                  placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;"
                  id="new-password"
                  value={this.state.newPassword}
                  handleTextInputOnChange={this.handleNewPasswordOnChange}
                />
                {this.state.newPswErrValidation ? (
                  <InputErrorMessage
                    errorText={this.state.newPswErrValidation}
                  />
                ) : null}
              </div>
              <PrimaryButton
                primaryButtonText="Change password"
                activatePrimaryWithEnter={true}
                handlePrimaryBtnOnClick={this.handlePasswordOnChange}
              />
            </form>
          </>
        )}
      </ModalBox>
    );
  }
}

export default ChangePasswordModal;
